import { styled } from '@material-ui/core'

export const StyledFooter = styled('div')(() => ({
  flex: '0 1 40px'
}))
